import React from 'react';
import './Stats.scss';

const Stats = () => {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats-grid">
          <div className="stat-item">
            <h2>100+</h2>
            <p>Projects Completed</p>
          </div>
          <div className="stat-item">
            <h2>50+</h2>
            <p>Happy Clients</p>
          </div>
          <div className="stat-item">
            <h2>15+</h2>
            <p>Years Experience</p>
          </div>
          <div className="stat-item">
            <h2>24/7</h2>
            <p>Support Available</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;